import * as React from "react";
import { Breadcrumbs, Typography } from "@mui/material";
import { useLocation } from "react-router";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { startCase } from "lodash";
import styles from "./bread-crumbs.module.scss";
import { routes } from "../../../constants";

const { subRoutes } = routes.clientPortal;

const breadCrumbs = {
  [subRoutes.dashBoard.name]: { label: "Dashboard" },
  [subRoutes.appointments.name]: { label: "Appointments" },
  [subRoutes.medicalReports.name]: { label: "Medical Reports" },
  [subRoutes.branches.name]: { label: "Branches" },
  [subRoutes.lab.name]: { label: "Lab" },
  [subRoutes.billing.name]: { label: "Billing" },
  [subRoutes.settings.name]: { label: "Settings" }
};

const BreadCrumbs = (): React.JSX.Element => {
  const path = useLocation();
  const segments = path.pathname.split("/")[2];

  return (
    <Breadcrumbs
      separator={<ChevronRightIcon />}
      aria-label="breadcrumb"
      className={styles.breadCrumbsContainer}
    >
      <Typography variant="h5">{startCase(breadCrumbs[segments]?.label)}</Typography>
      <div />
    </Breadcrumbs>
  );
};

export default BreadCrumbs;
